import React from 'react'
import {Button, Image, Modal} from "react-bootstrap";
import useAPI from "../../../hooks/useAPI";
import pdfIcon from '../../../../img/icons/pdf.svg'

export default function MilestoneFilesModal({files, show, onHide}){
    const api = useAPI()

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header>
                <Modal.Title>Документы</Modal.Title>
                <Button onClick={onHide} className='btn-close ms-auto' variant='link' size='sm'/>
            </Modal.Header>
            <Modal.Body>
                <Modal.Title style={{fontSize: 18, fontWeight: 600}}>Файлы</Modal.Title>
                <ul style={{listStyle: "none", marginTop: 10}}>
                    {files.map((file) => <li
                        style={{cursor: "pointer", color: '#0D6EFD', display: 'flex', gap: 12, alignItems: 'center'}}
                        onClick={() => api.download(`/minioFiles/download/${file.id}`, file.name)}
                    >
                        <Image src={pdfIcon} style={{width: 20, alignSelf: 'flex-start'}}/>
                        <p style={{wordBreak: 'break-all'}}>
                            {file.name}
                        </p>
                    </li>)}
                </ul>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={onHide} className='ms-auto' variant='outline-primary' style={{fontWeight: 700}}>OK</Button>
            </Modal.Footer>
        </Modal>
    )
}